import ActionTypes from '../constants/ActionTypes';

export const enableSingleProblemView = () => ({
  type: ActionTypes.ENABLE_SINGLE_PROBLEM_VIEW,
});

export const disableSingleProblemView = () => ({
  type: ActionTypes.DISABLE_SINGLE_PROBLEM_VIEW,
});

export const showPreparingAssessmentModal = () => ({
  type: ActionTypes.SHOW_PREPARING_ASSESSMENT_MODAL,
});

export const hidePreparingAssessmentModal = () => ({
  type: ActionTypes.HIDE_PREPARING_ASSESSMENT_MODAL,
});

export const appOnline = () => ({
  type: ActionTypes.APP_ONLINE,
});

export const appOffline = () => ({
  type: ActionTypes.APP_OFFLINE,
});

export const checkUrlForIframe = url => ({
  type: ActionTypes.CHECK_URL_FOR_IFRAME,
  url,
});

export const clearUrlForIframeData = () => ({
  type: ActionTypes.CLEAR_URL_FOR_IFRAME_DATA,
});

export const showAutoSubmitModalAction = () => ({
  type: ActionTypes.SHOW_AUTO_SUBMIT_MODAL,
});

export const hideAutoSubmitModalAction = () => ({
  type: ActionTypes.HIDE_AUTO_SUBMIT_MODAL,
});

export const setAutoSubmitReason = reason => ({
  type: ActionTypes.SET_AUTO_SUBMIT_REASON,
  reason,
});
